import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PAGEPATHS, USERTYPES } from "components/Common/Constant";

const AdminAuthmiddleware = (props) => {
  const user = useSelector((state) => state?.users.users)

  if (Object.keys(user).length === 0) {
    return (
      <Navigate to={{ pathname: PAGEPATHS.Login, state: { from: props.location } }} />
    );
  }

  if (Object.keys(user).length !== 0 && user.userType !== USERTYPES.Admin) {
    return (
      <Navigate to={{ pathname: PAGEPATHS.Forbidden, state: { from: props.location } }} />
    );
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default AdminAuthmiddleware;
